// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveProjectStageMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  stage: Types.Stage;
  projectStageStatus?: Types.InputMaybe<Types.ProjectStageStatus>;
}>;


export type SaveProjectStageMutation = { __typename?: 'Mutation', saveProjectStage: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };


export const SaveProjectStageDocument = gql`
    mutation SaveProjectStage($projectId: ID!, $stage: Stage!, $projectStageStatus: ProjectStageStatus) {
  saveProjectStage(
    input: {projectId: $projectId, stage: $stage, projectStageStatus: $projectStageStatus}
  ) {
    emptyResult
  }
}
    `;

/**
 * __useSaveProjectStageMutation__
 *
 * To run a mutation, you first call `useSaveProjectStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProjectStageMutation, { data, loading, error }] = useSaveProjectStageMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      stage: // value for 'stage'
 *      projectStageStatus: // value for 'projectStageStatus'
 *   },
 * });
 */
export function useSaveProjectStageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveProjectStageMutation, SaveProjectStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveProjectStageMutation, SaveProjectStageMutationVariables>(SaveProjectStageDocument, options);
      }
export type SaveProjectStageMutationHookResult = ReturnType<typeof useSaveProjectStageMutation>;
export type SaveProjectStageMutationResult = ApolloReactCommon.MutationResult<SaveProjectStageMutation>;